import React, { Component } from "react";
import withRouter from "../../withRouter/withRouter";

import "./Stories.css";

import no_image_img from "../../../no-image.png";
import ListScroll from "../../ListScroll/ListScroll";

class Stories extends Component {
    constructor(props) {
        super(props);
        this.no_image = { url: no_image_img };
    }
    state = { opened: null };
    render() {
        let { opened } = this.state;
        let { stories, router } = this.props;

        if (!stories || stories.length == 0) return null;
        return (
            <div className='stories container'>
                <div className='caption'>استوری ها</div>
                <div className='wraper'>
                    <ListScroll
                        items={stories}
                        key={"id"}
                        Component={(s, key) => {
                            s = s.item;
                            let { media, name, description } = s;

                            return (
                                <div
                                    className='story'
                                    onClick={(ev) => {
                                        this.setState({ opened: s });
                                    }}
                                >
                                    <div className='media'>
                                        {media.type === "image" ? (
                                            <img src={media.url} alt='' />
                                        ) : (
                                            <video src={media.url}></video>
                                        )}
                                    </div>
                                    <div className='name'>{name}</div>
                                </div>
                            );
                        }}
                    />
                </div>
                {opened && (
                    <div
                        className='opened'
                        onClick={(ev) => {
                            this.setState({ opened: null });
                        }}
                    >
                        <div className='container'>
                            {opened.media.type === "image" ? (
                                <img
                                    className='media'
                                    src={opened.media.url}
                                    alt=''
                                />
                            ) : (
                                <video
                                    className='media'
                                    src={opened.media.url}
                                    controls
                                    autoPlay
                                ></video>
                            )}
                            <div className='name'>{opened.name}</div>
                            <div className='descroption'>
                                {opened.description}
                            </div>
                            <div
                                className='close'
                                onClick={(ev) => {
                                    this.setState({ opened: null });
                                }}
                            >
                                <i className='ri-close-circle-line'></i>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(Stories);
